import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/pagetemplate/HomePage.vue'; 
import PortfolioPage from '@/pagetemplate/PortfolioPage.vue';
import WebDesign from '@/components/portfolio/WebDesign.vue';
import UIDesign from '@/components/portfolio/UIDesign.vue';
import VideoEditing from '@/components/portfolio/VideoEditing.vue';
import AICG from '@/components/portfolio/AICG.vue';
import PortfolioIllustration from '@/components/portfolio/PortfolioIllustration.vue';
import GraphicDesign from '@/components/portfolio/GraphicDesign.vue';
import PortfolioInformation from '@/components/portfolio/PortfolioInformation.vue';

const routes = [
  {
    path: '/', 
    name: 'Home',
    component: HomePage 
  },
  {
    path: '/portfolio', 
    name: 'Portfolio',
    component: PortfolioPage 
  },
  {
    path: '/web-design',
    name: 'WebDesign',
    component: WebDesign
  },
  {
    path: '/ui-design',
    name: 'UIDesign',
    component: UIDesign
  },
  {
    path: '/video-editing',
    name: 'VideoEditing',
    component: VideoEditing
  },
  {
    path: '/aicg',
    name: 'AICG',
    component: AICG
  },
  {
    path: '/illustration',
    name: 'Illustration',
    component: PortfolioIllustration
  },
  {
    path: '/graphic-design',
    name: 'GraphicDesign',
    component: GraphicDesign
  },
  {
    path: '/information',
    name: 'Information',
    component: PortfolioInformation
  }
];

const router = createRouter({
  history: createWebHistory('/resume2025/'),
  routes
});

export default router;
